import React from 'react';
import headerVector from './assets/3d-header-vector.png';
import code3d from './assets/3d-code.png';
import art3d from './assets/3d-art.png';
import laptop3d from './assets/3d-laptop.png';
import music3d from './assets/3d-music.png';
import travel3d from './assets/3d-travel.png';
import './css/Overlay.css';

const floatingIcons = [
  { src: code3d, alt: 'Code' },
  { src: art3d, alt: 'Art' },
  { src: music3d, alt: 'Music' },
  { src: travel3d, alt: 'Travel' },
];

const Overlay = () => {
  return (
    <div className="overlay">

      {/* ambient glow rings */}
      {/* <div className="glow-ring glow-ring--1" />
      <div className="glow-ring glow-ring--2" />
      <div className="glow-ring glow-ring--3" /> */}

      {/* centre hero */}
      <div className='overlay-container'>
        <svg viewBox="0 0 500 500" className="circular-text">
          <defs>
            <path
              id="textPath"
              d="M 250, 250
                  m -200, 0
                  a 200,200 0 1,1 400,0
                  a 200,200 0 1,1 -400,0"
            />
          </defs>

          <text fill="#d1d5db" fontSize="40" fontFamily="Inter, sans-serif">
            <textPath href="#textPath" startOffset="50%" textAnchor="middle">
              build with
            </textPath>
          </text>
        </svg>
        <p className="hero-name">Shruti</p>

        <div className="overlay__hero">
          <div className="hero-pulse" />
          <img
            src={headerVector}
            alt="Shruti Sharma"
            className="overlay__hero-img"
            draggable={false}
          />
        </div>
      </div>


      {/* vertical icon strip — outside hero, right boundary */}

      {/* scroll cue */}
      <div className="scroll-cue">
        <div className="scroll-cue__mouse">
          <div className="scroll-cue__wheel" />
        </div>
        <div className="scroll-cue__arrows">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default Overlay;